/** Форматирует число: убирает trailing zeros (0.01810000 → 0.0181, 0.00 → 0) */
export const formatBtc = (value: number | string | null | undefined, decimals = 8): string => {
  const num = Number(value);
  if (!Number.isFinite(num)) return '0';
  return parseFloat(num.toFixed(decimals)).toString();
};

export const roundNumberToTwoPrecision = (value: number) => {
  return Math.round(value * 100) / 100;
};

export const formatNum = (n: any, min = 0, max = 2) => {
  if (n === undefined || n === null || n === '') return '';

  const str = String(n)
    .trim()
    .replace(/[\u00A0\s]/g, '')
    .replace(',', '.');
  const num = Number(str);
  if (!Number.isFinite(num)) return '';

  const parts = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
    useGrouping: true,
  }).formatToParts(n);

  return parts
    .map(p => (p.type === 'group' ? '\u00A0' : p.type === 'decimal' ? '.' : p.value))
    .join('');
};
